import React, { useState } from "react";
import { Banner, Icon, Typography } from "@plum-xoxo/admin-dsm";
import { useHistory } from "react-router-dom";
import { app_path } from "config";

const BrandApprovalWarningBanner = (props) => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const history = useHistory();

  const brand_kyc_details = props.kybStatus?.brand_kyc_details || [];

  const isKycApproved =
    brand_kyc_details.filter((product) => product?.brand_kyb_status)?.length >
      0 || false;

  return (
    <Banner
      className="mt-16"
      color="info"
      iconName={null}
      description={
        <Typography.HelperText component="span" className="d-inline">
          <Typography.LabelText component="span">Note:</Typography.LabelText>{" "}
          Some vouchers need additional approvals to be activated.{" "}
          <Typography.HelperText
            className="cursor-pointer"
            component="span"
            color="blue"
            shade="c200"
            onClick={() => {
              history.push({
                pathname: `/${app_path}/accounts/platform-preferences`,
                activeTab: 7,
                title: "verifications",
              });
            }}
          >
            Apply Now
          </Typography.HelperText>{" "}
          {/* or{" "}
          <Typography.HelperText
            className="cursor-pointer"
            component="span"
            color="blue"
            shade="c200"
            onClick={() => {
              history.push({
                pathname: `/${app_path}/accounts/platform-preferences`,
                activeTab: 6,
              });
            }}
          >
            Remind me later
          </Typography.HelperText>{" "} */}
        </Typography.HelperText>
      }
    />
  ); 
};

export default BrandApprovalWarningBanner;
